'use client';

import React from 'react';
import styles from './UploadProjectFormSuccess.module.scss';
import { Button, ButtonColor, ButtonType } from '@/components/button/Button';
import { useTranslation } from '@app/i18n/useTranslationClient';
import { useTranslatedRouter } from '@/hooks/useTranslatedRouter';
import classNames from 'classnames';
import { isAuthenticatedClient } from '@packages/authenticator';

interface IUploadProjectFormSuccess {
    modalTitle: string;
    modalContent: string;
    setFormSent(state: boolean): void;
    closeModal(): void;
    showNextProjectButton?: boolean;
    openModal?(): void;
}

export const UploadProjectFormSuccess: React.FC<IUploadProjectFormSuccess> = ({
    modalTitle,
    modalContent,
    setFormSent,
    closeModal,
    openModal,
    showNextProjectButton = true,
}) => {
    const { t } = useTranslation();
    const isAuthenticated = isAuthenticatedClient();

    const { push } = useTranslatedRouter();

    const closeModalSuccess = () => {
        setFormSent(false);
        closeModal();
        if (isAuthenticated) {
            push('ACCOUNT_SENT_PROJECTS');
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    };

    const sendNextProject = () => {
        setFormSent(false);
        openModal?.();
    };

    return (
        <div className={styles.wrapper}>
            <p className={classNames('h4', styles.wrapperTitle)}>{modalTitle}</p>
            <p className={styles.wrapperContent}>{modalContent}</p>
            <Button buttonType={ButtonType.BUTTON} buttonColor={ButtonColor.BLACK} onClick={closeModalSuccess}>
                {t('translations.projectUpload.success.close')}
            </Button>
            {showNextProjectButton && (
                <Button
                    buttonType={ButtonType.BUTTON}
                    buttonColor={ButtonColor.TRANSPARENT_BLACK}
                    onClick={sendNextProject}>
                    {t('translations.projectUpload.success.nextProject')}
                </Button>
            )}
        </div>
    );
};
